import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import styles from "./PaymentResult.module.css";
import { useStore } from "Store";

const STORAGE_SESSION_KEY = "checkout_session_id";
const STORAGE_AMOUNT_KEY = "checkout_amount";

const PaymentSuccess: React.FC = () => {
    const navigate = useNavigate();
    const { setmainStatus } = useStore((state: any) => state);

    const [searchParams] = useSearchParams();
    const paramSession = searchParams.get("session_id") || undefined;
    const paramAmount = searchParams.get("amount") || undefined;

    const [sessionId, setSessionId] = useState<string | undefined>(undefined);
    const [amount, setAmount] = useState<string | undefined>(undefined);

    useEffect(() => {
        // Prefer localStorage values (saved before redirect). Fallback to query params.
        const storedSession = localStorage.getItem(STORAGE_SESSION_KEY);
        const storedAmount = localStorage.getItem(STORAGE_AMOUNT_KEY);
        setSessionId(storedSession || paramSession || undefined);
        setAmount(storedAmount || paramAmount || undefined);
        setmainStatus("payments");
        return () => {
            // Clear stored values when leaving this page
            try {
                localStorage.removeItem(STORAGE_SESSION_KEY);
                localStorage.removeItem(STORAGE_AMOUNT_KEY);
            } catch (e) {}
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleCloseAndClear = (to: string) => {
        try {
            localStorage.removeItem(STORAGE_SESSION_KEY);
            localStorage.removeItem(STORAGE_AMOUNT_KEY);
        } catch (e) {}
        navigate(to);
    };

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div className={`${styles.iconCircle} ${styles.success}`}>
                    ✓
                </div>
                <div>
                    <h2 className={styles.title}>Payment successful</h2>
                    <div className={styles.subtitle}>
                        Thank you — your payment was processed successfully.
                    </div>
                </div>
            </div>

            <div className={styles.body}>
                <div className={styles.left}>
                    <p className={styles.muted}>
                        A receipt has been emailed to you when available. You
                        can also view the payment details below.
                    </p>
                    {/* <div className={styles.card} style={{ marginTop: 12 }}>
                        <div className={styles.metaItem}>
                            <strong>Amount:</strong>{" "}
                            <span className={styles.largeAmount}>
                                {amount ? `$${amount}` : "—"}
                            </span>
                        </div>
                        <div className={styles.metaItem}>
                            <strong>Session ID:</strong>{" "}
                            <span className={styles.muted}>
                                {sessionId || "—"}
                            </span>
                        </div>
                        <div className={styles.metaItem}>
                            <strong>Status:</strong> Completed
                        </div>
                    </div> */}

                    <div className={styles.btnRow}>
                        <button
                            className={styles.secondaryBtn}
                            onClick={() => handleCloseAndClear("/auth/Tax-Summary")}>
                            View Tax Summary
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaymentSuccess;
